import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
    getTransactionsSuccessful,
    getTransactionsError,
    getFilteredTransactionsSuccessful,
    getFilteredTransactionsError,
    createInvoiceError,
    createInvoiceSuccess,
    getInvoicesError,
    getInvoicesSuccessful
} from "./actions";
import ReportService from "./service";
import { PaymentsReportActionTypes } from "./actionTypes";

function* getAllTransactions({payload}) {
    try {
        const response = yield call(ReportService.getTransactions, payload);
        const rsp = getTransactionsSuccessful(response);
        yield put(rsp);
    } catch (error) {
        yield put(getTransactionsError(error));
    }
}

function* getAllInvoices({payload}) {
    try {
        const response = yield call(ReportService.getInvoices, payload);
        const rsp = getInvoicesSuccessful(response);
        yield put(rsp);
    } catch (error) {
        yield put(getInvoicesError(error));
    }
}

export function* watchGetInvoicing() {
    yield takeEvery(PaymentsReportActionTypes.PROFREPORTS_LIST_GET, getAllTransactions);
}


export function* watchGetProffPayments() {
    yield takeEvery(PaymentsReportActionTypes.PROFREPORT_LIST_GET, getAllInvoices);
}


function* getFiltered({payload}) {
    try {
        const response = yield call(ReportService.getFilteredTransactions, { professionalID: payload });
        const rsp = getFilteredTransactionsSuccessful(response);
        yield put(rsp);
    } catch (error) {
        yield put(getFilteredTransactionsError(error));
    }
}
export function* watchFilterInvoicing() {
    yield takeEvery(PaymentsReportActionTypes.PROFREPORTS_GET_FILTERED, getFiltered);
}


function* createInvoiceSaga({payload}) {
    try {
        const response = yield call(ReportService.createInvoice, { transactions: payload });
        const rsp = createInvoiceSuccess(response);
        yield put(rsp);
    } catch (error) {
        yield put(createInvoiceError(error));
    }
}
export function* watchCreateInvoice() {
    yield takeEvery(PaymentsReportActionTypes.PROFREPORTS_CREATE, createInvoiceSaga);
}



function* profReportSaga() {
    yield all([
        fork(watchGetInvoicing),
        fork(watchFilterInvoicing),
        fork(watchCreateInvoice),
        fork(watchGetProffPayments),
    ]);
}



export default profReportSaga;
